/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ContactSupportRouteImport } from './routes/contact-support'
import { Route as AdminSettingRouteImport } from './routes/admin-setting'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProjectSettingsIndexRouteImport } from './routes/project-settings.index'
import { Route as SettingsWorkingTimeModelRouteImport } from './routes/settings.working-time-model'
import { Route as SettingsWbsDetailsRouteImport } from './routes/settings.wbs-details'
import { Route as SettingsVendorRouteImport } from './routes/settings.vendor'
import { Route as SettingsTasksRouteImport } from './routes/settings.tasks'
import { Route as SettingsProjectsRouteImport } from './routes/settings.projects'
import { Route as SettingsProjectPropertiesRouteImport } from './routes/settings.project-properties'
import { Route as SettingsOrgStructureRouteImport } from './routes/settings.org-structure'
import { Route as SettingsOrdersRouteImport } from './routes/settings.orders'
import { Route as SettingsLocationsRouteImport } from './routes/settings.locations'
import { Route as SettingsHolidaysRouteImport } from './routes/settings.holidays'
import { Route as SettingsEmployeesRouteImport } from './routes/settings.employees'
import { Route as SettingsCustomerRouteImport } from './routes/settings.customer'
import { Route as SettingsCostGroupsRouteImport } from './routes/settings.cost-groups'
import { Route as ProjectSettingsEmployeeProjectModelsRouteImport } from './routes/project-settings.employee-project-models'
import { Route as SettingsCostGroupsIndexRouteImport } from './routes/settings.cost-groups.index'
import { Route as SettingsCostGroupsYearRatesRouteImport } from './routes/settings.cost-groups.year-rates'
import { Route as SettingsCostGroupsEmployeeCostGroupRouteImport } from './routes/settings.cost-groups.employee-cost-group'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactSupportRoute = ContactSupportRouteImport.update({
  id: '/contact-support',
  path: '/contact-support',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSettingRoute = AdminSettingRouteImport.update({
  id: '/admin-setting',
  path: '/admin-setting',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectSettingsIndexRoute = ProjectSettingsIndexRouteImport.update({
  id: '/project-settings/',
  path: '/project-settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsWorkingTimeModelRoute =
  SettingsWorkingTimeModelRouteImport.update({
    id: '/working-time-model',
    path: '/working-time-model',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsWbsDetailsRoute = SettingsWbsDetailsRouteImport.update({
  id: '/wbs-details',
  path: '/wbs-details',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsVendorRoute = SettingsVendorRouteImport.update({
  id: '/vendor',
  path: '/vendor',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsTasksRoute = SettingsTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProjectsRoute = SettingsProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProjectPropertiesRoute =
  SettingsProjectPropertiesRouteImport.update({
    id: '/project-properties',
    path: '/project-properties',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsOrgStructureRoute = SettingsOrgStructureRouteImport.update({
  id: '/org-structure',
  path: '/org-structure',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsOrdersRoute = SettingsOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsLocationsRoute = SettingsLocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsHolidaysRoute = SettingsHolidaysRouteImport.update({
  id: '/holidays',
  path: '/holidays',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsEmployeesRoute = SettingsEmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsCustomerRoute = SettingsCustomerRouteImport.update({
  id: '/customer',
  path: '/customer',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsCostGroupsRoute = SettingsCostGroupsRouteImport.update({
  id: '/cost-groups',
  path: '/cost-groups',
  getParentRoute: () => SettingsRoute,
} as any)
const ProjectSettingsEmployeeProjectModelsRoute =
  ProjectSettingsEmployeeProjectModelsRouteImport.update({
    id: '/project-settings/employee-project-models',
    path: '/project-settings/employee-project-models',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsCostGroupsIndexRoute = SettingsCostGroupsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsCostGroupsRoute,
} as any)
const SettingsCostGroupsYearRatesRoute =
  SettingsCostGroupsYearRatesRouteImport.update({
    id: '/year-rates',
    path: '/year-rates',
    getParentRoute: () => SettingsCostGroupsRoute,
  } as any)
const SettingsCostGroupsEmployeeCostGroupRoute =
  SettingsCostGroupsEmployeeCostGroupRouteImport.update({
    id: '/employee-cost-group',
    path: '/employee-cost-group',
    getParentRoute: () => SettingsCostGroupsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin-setting': typeof AdminSettingRoute
  '/contact-support': typeof ContactSupportRoute
  '/settings': typeof SettingsRouteWithChildren
  '/project-settings/employee-project-models': typeof ProjectSettingsEmployeeProjectModelsRoute
  '/settings/cost-groups': typeof SettingsCostGroupsRouteWithChildren
  '/settings/customer': typeof SettingsCustomerRoute
  '/settings/employees': typeof SettingsEmployeesRoute
  '/settings/holidays': typeof SettingsHolidaysRoute
  '/settings/locations': typeof SettingsLocationsRoute
  '/settings/orders': typeof SettingsOrdersRoute
  '/settings/org-structure': typeof SettingsOrgStructureRoute
  '/settings/project-properties': typeof SettingsProjectPropertiesRoute
  '/settings/projects': typeof SettingsProjectsRoute
  '/settings/tasks': typeof SettingsTasksRoute
  '/settings/vendor': typeof SettingsVendorRoute
  '/settings/wbs-details': typeof SettingsWbsDetailsRoute
  '/settings/working-time-model': typeof SettingsWorkingTimeModelRoute
  '/project-settings': typeof ProjectSettingsIndexRoute
  '/settings/cost-groups/employee-cost-group': typeof SettingsCostGroupsEmployeeCostGroupRoute
  '/settings/cost-groups/year-rates': typeof SettingsCostGroupsYearRatesRoute
  '/settings/cost-groups/': typeof SettingsCostGroupsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin-setting': typeof AdminSettingRoute
  '/contact-support': typeof ContactSupportRoute
  '/settings': typeof SettingsRouteWithChildren
  '/project-settings/employee-project-models': typeof ProjectSettingsEmployeeProjectModelsRoute
  '/settings/customer': typeof SettingsCustomerRoute
  '/settings/employees': typeof SettingsEmployeesRoute
  '/settings/holidays': typeof SettingsHolidaysRoute
  '/settings/locations': typeof SettingsLocationsRoute
  '/settings/orders': typeof SettingsOrdersRoute
  '/settings/org-structure': typeof SettingsOrgStructureRoute
  '/settings/project-properties': typeof SettingsProjectPropertiesRoute
  '/settings/projects': typeof SettingsProjectsRoute
  '/settings/tasks': typeof SettingsTasksRoute
  '/settings/vendor': typeof SettingsVendorRoute
  '/settings/wbs-details': typeof SettingsWbsDetailsRoute
  '/settings/working-time-model': typeof SettingsWorkingTimeModelRoute
  '/project-settings': typeof ProjectSettingsIndexRoute
  '/settings/cost-groups/employee-cost-group': typeof SettingsCostGroupsEmployeeCostGroupRoute
  '/settings/cost-groups/year-rates': typeof SettingsCostGroupsYearRatesRoute
  '/settings/cost-groups': typeof SettingsCostGroupsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin-setting': typeof AdminSettingRoute
  '/contact-support': typeof ContactSupportRoute
  '/settings': typeof SettingsRouteWithChildren
  '/project-settings/employee-project-models': typeof ProjectSettingsEmployeeProjectModelsRoute
  '/settings/cost-groups': typeof SettingsCostGroupsRouteWithChildren
  '/settings/customer': typeof SettingsCustomerRoute
  '/settings/employees': typeof SettingsEmployeesRoute
  '/settings/holidays': typeof SettingsHolidaysRoute
  '/settings/locations': typeof SettingsLocationsRoute
  '/settings/orders': typeof SettingsOrdersRoute
  '/settings/org-structure': typeof SettingsOrgStructureRoute
  '/settings/project-properties': typeof SettingsProjectPropertiesRoute
  '/settings/projects': typeof SettingsProjectsRoute
  '/settings/tasks': typeof SettingsTasksRoute
  '/settings/vendor': typeof SettingsVendorRoute
  '/settings/wbs-details': typeof SettingsWbsDetailsRoute
  '/settings/working-time-model': typeof SettingsWorkingTimeModelRoute
  '/project-settings/': typeof ProjectSettingsIndexRoute
  '/settings/cost-groups/employee-cost-group': typeof SettingsCostGroupsEmployeeCostGroupRoute
  '/settings/cost-groups/year-rates': typeof SettingsCostGroupsYearRatesRoute
  '/settings/cost-groups/': typeof SettingsCostGroupsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin-setting'
    | '/contact-support'
    | '/settings'
    | '/project-settings/employee-project-models'
    | '/settings/cost-groups'
    | '/settings/customer'
    | '/settings/employees'
    | '/settings/holidays'
    | '/settings/locations'
    | '/settings/orders'
    | '/settings/org-structure'
    | '/settings/project-properties'
    | '/settings/projects'
    | '/settings/tasks'
    | '/settings/vendor'
    | '/settings/wbs-details'
    | '/settings/working-time-model'
    | '/project-settings'
    | '/settings/cost-groups/employee-cost-group'
    | '/settings/cost-groups/year-rates'
    | '/settings/cost-groups/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin-setting'
    | '/contact-support'
    | '/settings'
    | '/project-settings/employee-project-models'
    | '/settings/customer'
    | '/settings/employees'
    | '/settings/holidays'
    | '/settings/locations'
    | '/settings/orders'
    | '/settings/org-structure'
    | '/settings/project-properties'
    | '/settings/projects'
    | '/settings/tasks'
    | '/settings/vendor'
    | '/settings/wbs-details'
    | '/settings/working-time-model'
    | '/project-settings'
    | '/settings/cost-groups/employee-cost-group'
    | '/settings/cost-groups/year-rates'
    | '/settings/cost-groups'
  id:
    | '__root__'
    | '/'
    | '/admin-setting'
    | '/contact-support'
    | '/settings'
    | '/project-settings/employee-project-models'
    | '/settings/cost-groups'
    | '/settings/customer'
    | '/settings/employees'
    | '/settings/holidays'
    | '/settings/locations'
    | '/settings/orders'
    | '/settings/org-structure'
    | '/settings/project-properties'
    | '/settings/projects'
    | '/settings/tasks'
    | '/settings/vendor'
    | '/settings/wbs-details'
    | '/settings/working-time-model'
    | '/project-settings/'
    | '/settings/cost-groups/employee-cost-group'
    | '/settings/cost-groups/year-rates'
    | '/settings/cost-groups/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminSettingRoute: typeof AdminSettingRoute
  ContactSupportRoute: typeof ContactSupportRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  ProjectSettingsEmployeeProjectModelsRoute: typeof ProjectSettingsEmployeeProjectModelsRoute
  ProjectSettingsIndexRoute: typeof ProjectSettingsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact-support': {
      id: '/contact-support'
      path: '/contact-support'
      fullPath: '/contact-support'
      preLoaderRoute: typeof ContactSupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-setting': {
      id: '/admin-setting'
      path: '/admin-setting'
      fullPath: '/admin-setting'
      preLoaderRoute: typeof AdminSettingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/project-settings/': {
      id: '/project-settings/'
      path: '/project-settings'
      fullPath: '/project-settings'
      preLoaderRoute: typeof ProjectSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/working-time-model': {
      id: '/settings/working-time-model'
      path: '/working-time-model'
      fullPath: '/settings/working-time-model'
      preLoaderRoute: typeof SettingsWorkingTimeModelRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/wbs-details': {
      id: '/settings/wbs-details'
      path: '/wbs-details'
      fullPath: '/settings/wbs-details'
      preLoaderRoute: typeof SettingsWbsDetailsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/vendor': {
      id: '/settings/vendor'
      path: '/vendor'
      fullPath: '/settings/vendor'
      preLoaderRoute: typeof SettingsVendorRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/tasks': {
      id: '/settings/tasks'
      path: '/tasks'
      fullPath: '/settings/tasks'
      preLoaderRoute: typeof SettingsTasksRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/projects': {
      id: '/settings/projects'
      path: '/projects'
      fullPath: '/settings/projects'
      preLoaderRoute: typeof SettingsProjectsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/project-properties': {
      id: '/settings/project-properties'
      path: '/project-properties'
      fullPath: '/settings/project-properties'
      preLoaderRoute: typeof SettingsProjectPropertiesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/org-structure': {
      id: '/settings/org-structure'
      path: '/org-structure'
      fullPath: '/settings/org-structure'
      preLoaderRoute: typeof SettingsOrgStructureRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/orders': {
      id: '/settings/orders'
      path: '/orders'
      fullPath: '/settings/orders'
      preLoaderRoute: typeof SettingsOrdersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/locations': {
      id: '/settings/locations'
      path: '/locations'
      fullPath: '/settings/locations'
      preLoaderRoute: typeof SettingsLocationsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/holidays': {
      id: '/settings/holidays'
      path: '/holidays'
      fullPath: '/settings/holidays'
      preLoaderRoute: typeof SettingsHolidaysRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/employees': {
      id: '/settings/employees'
      path: '/employees'
      fullPath: '/settings/employees'
      preLoaderRoute: typeof SettingsEmployeesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/customer': {
      id: '/settings/customer'
      path: '/customer'
      fullPath: '/settings/customer'
      preLoaderRoute: typeof SettingsCustomerRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/cost-groups': {
      id: '/settings/cost-groups'
      path: '/cost-groups'
      fullPath: '/settings/cost-groups'
      preLoaderRoute: typeof SettingsCostGroupsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/project-settings/employee-project-models': {
      id: '/project-settings/employee-project-models'
      path: '/project-settings/employee-project-models'
      fullPath: '/project-settings/employee-project-models'
      preLoaderRoute: typeof ProjectSettingsEmployeeProjectModelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/cost-groups/': {
      id: '/settings/cost-groups/'
      path: '/'
      fullPath: '/settings/cost-groups/'
      preLoaderRoute: typeof SettingsCostGroupsIndexRouteImport
      parentRoute: typeof SettingsCostGroupsRoute
    }
    '/settings/cost-groups/year-rates': {
      id: '/settings/cost-groups/year-rates'
      path: '/year-rates'
      fullPath: '/settings/cost-groups/year-rates'
      preLoaderRoute: typeof SettingsCostGroupsYearRatesRouteImport
      parentRoute: typeof SettingsCostGroupsRoute
    }
    '/settings/cost-groups/employee-cost-group': {
      id: '/settings/cost-groups/employee-cost-group'
      path: '/employee-cost-group'
      fullPath: '/settings/cost-groups/employee-cost-group'
      preLoaderRoute: typeof SettingsCostGroupsEmployeeCostGroupRouteImport
      parentRoute: typeof SettingsCostGroupsRoute
    }
  }
}

interface SettingsCostGroupsRouteChildren {
  SettingsCostGroupsEmployeeCostGroupRoute: typeof SettingsCostGroupsEmployeeCostGroupRoute
  SettingsCostGroupsYearRatesRoute: typeof SettingsCostGroupsYearRatesRoute
  SettingsCostGroupsIndexRoute: typeof SettingsCostGroupsIndexRoute
}

const SettingsCostGroupsRouteChildren: SettingsCostGroupsRouteChildren = {
  SettingsCostGroupsEmployeeCostGroupRoute:
    SettingsCostGroupsEmployeeCostGroupRoute,
  SettingsCostGroupsYearRatesRoute: SettingsCostGroupsYearRatesRoute,
  SettingsCostGroupsIndexRoute: SettingsCostGroupsIndexRoute,
}

const SettingsCostGroupsRouteWithChildren =
  SettingsCostGroupsRoute._addFileChildren(SettingsCostGroupsRouteChildren)

interface SettingsRouteChildren {
  SettingsCostGroupsRoute: typeof SettingsCostGroupsRouteWithChildren
  SettingsCustomerRoute: typeof SettingsCustomerRoute
  SettingsEmployeesRoute: typeof SettingsEmployeesRoute
  SettingsHolidaysRoute: typeof SettingsHolidaysRoute
  SettingsLocationsRoute: typeof SettingsLocationsRoute
  SettingsOrdersRoute: typeof SettingsOrdersRoute
  SettingsOrgStructureRoute: typeof SettingsOrgStructureRoute
  SettingsProjectPropertiesRoute: typeof SettingsProjectPropertiesRoute
  SettingsProjectsRoute: typeof SettingsProjectsRoute
  SettingsTasksRoute: typeof SettingsTasksRoute
  SettingsVendorRoute: typeof SettingsVendorRoute
  SettingsWbsDetailsRoute: typeof SettingsWbsDetailsRoute
  SettingsWorkingTimeModelRoute: typeof SettingsWorkingTimeModelRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsCostGroupsRoute: SettingsCostGroupsRouteWithChildren,
  SettingsCustomerRoute: SettingsCustomerRoute,
  SettingsEmployeesRoute: SettingsEmployeesRoute,
  SettingsHolidaysRoute: SettingsHolidaysRoute,
  SettingsLocationsRoute: SettingsLocationsRoute,
  SettingsOrdersRoute: SettingsOrdersRoute,
  SettingsOrgStructureRoute: SettingsOrgStructureRoute,
  SettingsProjectPropertiesRoute: SettingsProjectPropertiesRoute,
  SettingsProjectsRoute: SettingsProjectsRoute,
  SettingsTasksRoute: SettingsTasksRoute,
  SettingsVendorRoute: SettingsVendorRoute,
  SettingsWbsDetailsRoute: SettingsWbsDetailsRoute,
  SettingsWorkingTimeModelRoute: SettingsWorkingTimeModelRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminSettingRoute: AdminSettingRoute,
  ContactSupportRoute: ContactSupportRoute,
  SettingsRoute: SettingsRouteWithChildren,
  ProjectSettingsEmployeeProjectModelsRoute:
    ProjectSettingsEmployeeProjectModelsRoute,
  ProjectSettingsIndexRoute: ProjectSettingsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
